import update from 'immutability-helper'

import * as actions from '../../actions/actions'

const initialState = {
  campaignToEdit: {
    corporate: {},
    campaignName: '',
    campaignLogo: {},
    enabled: false,
    authorizationType:'',
  },
  corporateAuthType:'',
  error: ''
}

export default function campaignEdit(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_CAMPAIGN_EDIT_SUCCESS:
      return fetchCampaignEditSuccess(state, action)
    case actions.FETCH_CAMPAIGN_EDIT_FAILURE:
      return fetchCampaignEditFailure(state, action)
    case actions.EDIT_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE:
      return editCampaignCampaignNameFieldChange(state, action)
    case actions.EDIT_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE:
      return editCampaignCampaignLogoFieldChange(state, action)
    case actions.EDIT_CAMPAIGN_ENABLED_FILED_CHANGE:
      return editCampaignEnabledChange(state, action)
    case actions.EDIT_CAMPAIGN_CORPORATE_FILED_CHANGE:
      return editCampaignCorporateChange(state, action)
    case actions.EDIT_CAMPAIGN_CLEAN:
      return editCampaignClean(state, action)
    case actions.UPDATE_CAMPAIGN_EDIT_FAILURE:
      return UpdateCampaignError(state,action)
    case actions.EDIT_CAMPAIGN_AUTHORIZERS_CHANGE:
      return editCampaignAuthorizersChange(state,action)
    case actions.EDIT_CAMPAIGN_AUTH_TYPE_CHECK_SUCCESS:
      return editCampaignAuthorizersCheck(state,action)
    default:
      return state
  }
}

const UpdateCampaignError = (state,action) => {
  return {
    ...state,
    error: action.error
  }
}

const fetchCampaignEditSuccess = (state, action) => {
  return {
    ...state,
    campaignToEdit: action.value
  }
}

const fetchCampaignEditFailure = (state, action) => {
  return {
    ...state,
    error: action.value
  }
}

const editCampaignCorporateChange = (state, action) => {
  return update(
    state,
    {campaignToEdit: {corporate: {$set: action.value}}}
  )
}

const editCampaignCampaignNameFieldChange = (state, action) => {
  return update(
    state,
    {campaignToEdit: {campaignName: {$set: action.value}}}
  )
}

const editCampaignCampaignLogoFieldChange = (state, action) => {
  return update(
    state,
    {campaignToEdit: {campaignLogo: {$set: action.value}}}
  )
}

const editCampaignEnabledChange = (state, action) => {
  return update(
    state,
    {campaignToEdit: {enabled: {$set: action.value}}}
  )
}

const editCampaignAuthorizersChange = (state, action) => {
  return update(
      state,
      {campaignToEdit: {authorizationType: {$set: action.value}}}
  )
}

const editCampaignAuthorizersCheck = (state, action) => {
  return update(
      state,
      {corporateAuthType: {$set: action.value}}
  )
}

const editCampaignClean = (state, action) => {
  return initialState;
}